import * as squint_core from 'squint-cljs/core.js';
import { mergeHTMLPlugin } from './hljs-merge-plugin';
import * as docstring_toggler from './cljdoc.client.docstring-toggler.jsx';
import * as cljdoc_DOT_client_DOT_docstring_toggler from './cljdoc.client.docstring-toggler.jsx';
import { copyButtonPlugin } from './cljdoc.client.hljs-copy-button-plugin.jsx';
import * as cljdoc_DOT_client_DOT_hljs_copy_button_plugin from './cljdoc.client.hljs-copy-button-plugin.jsx';
import * as lib_search from './cljdoc.client.lib-search.jsx';
import * as cljdoc_DOT_client_DOT_lib_search from './cljdoc.client.lib-search.jsx';
import * as lib_switcher from './cljdoc.client.lib-switcher.jsx';
import * as cljdoc_DOT_client_DOT_lib_switcher from './cljdoc.client.lib-switcher.jsx';
import * as mobile from './cljdoc.client.mobile.jsx';
import * as cljdoc_DOT_client_DOT_mobile from './cljdoc.client.mobile.jsx';
import * as namespace_scroll from './cljdoc.client.namespace-scroll.jsx';
import * as cljdoc_DOT_client_DOT_namespace_scroll from './cljdoc.client.namespace-scroll.jsx';
import * as project_doc from './cljdoc.client.project-doc.jsx';
import * as cljdoc_DOT_client_DOT_project_doc from './cljdoc.client.project-doc.jsx';
import * as recent_doc_links from './cljdoc.client.recent-doc-links.jsx';
import * as cljdoc_DOT_client_DOT_recent_doc_links from './cljdoc.client.recent-doc-links.jsx';
import * as single_docset_search from './cljdoc.client.single-docset-search.jsx';
import * as cljdoc_DOT_client_DOT_single_docset_search from './cljdoc.client.single-docset-search.jsx';
import * as versions_form from './cljdoc.client.versions-form.jsx';
import * as cljdoc_DOT_client_DOT_versions_form from './cljdoc.client.versions-form.jsx';
lib_switcher.init();
lib_search.init();
versions_form.init();
docstring_toggler.init();
namespace_scroll.init();
mobile.init();
project_doc.init();
recent_doc_links.init();
single_docset_search.init();
window.mergeHTMLPlugin = mergeHTMLPlugin;
window.copyButtonPlugin = copyButtonPlugin;
